import * as isEqual from 'fast-deep-equal';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

export function dirtyCheck<U>(source: Observable<U>) {
  return function <T>(valueChanges: Observable<T>): Observable<boolean> {
    const isDirty$ = combineLatest([source, valueChanges]).pipe(
      map(
        ([a, b]) =>
          !isEqual(
            normalizeValue(structuredClone(a)),
            normalizeValue(structuredClone(b)),
          ),
      ),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    return isDirty$;
  };
}

// this function to trim all sub properties of an object which name is _resolved
function normalizeValue(value: any): any {
  if (value && typeof value === 'object') {
    for (const key in value) {
      if (
        key === '_resolved' ||
        key === '_includedFields' ||
        key === '_parent'
      ) {
        delete value[key];
      } else if (value[key] && typeof value[key] === 'object') {
        normalizeValue(value[key]);
      }
    }
  }
  return value;
}
